import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import config from 'react-global-configuration';

import Button from '../../../../components/Button';

import './style.scss';

const TestimonialFrontPage = ({ entities, ...props }) => {
  const { t } = useTranslation();
  const DEFAULT_LANGUAGE = config.get('DEFAULT_LANGUAGE');
  const { footer } = props;
  const path = footer.getIn([0, 'entity', 'paths', DEFAULT_LANGUAGE], '');

  return (
    <div className="TestimonialFrontPage">
      <Container>
        <div className="row">
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);

            return (
              <Node
                id={id}
                key={`${uuid}:${langcode}`}
                entity={entity}
                viewMode="small"
                className="col-12 col-md-4"
              />
            );
          })}
          <Button secondary href={path}>
            {t('buttons.testimonialFrontPageReadMore')}
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default TestimonialFrontPage;
